"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _reactWindow = require("react-window");

var _NoOptionMessage = _interopRequireDefault(require("./NoOptionMessage"));

var MenuList = function MenuList(props) {
  // eslint-disable-next-line react/prop-types
  var options = props.options,
      children = props.children,
      selectProps = props.selectProps,
      getValue = props.getValue;
  var itemHeight = 35;

  var _getValue = getValue(),
      _getValue2 = (0, _slicedToArray2["default"])(_getValue, 1),
      value = _getValue2[0];

  var optCount = children.length || 0;
  var initialOffset = options.indexOf(value) * itemHeight;
  var height = Math.min(260, itemHeight * Math.max(optCount, 1));

  if (!optCount) {
    return _react["default"].createElement(_NoOptionMessage["default"], null, selectProps.noOptionsMessage());
  }

  return _react["default"].createElement(_reactWindow.FixedSizeList, (0, _extends2["default"])({
    height: height,
    itemCount: optCount,
    itemSize: itemHeight,
    initialScrollOffset: initialOffset
  }, props), function (_ref) {
    var index = _ref.index,
        style = _ref.style;
    return _react["default"].createElement("div", {
      style: style
    }, children[index]);
  });
};

var _default = MenuList;
exports["default"] = _default;